import { render } from "./ConfigureDeal.vue?vue&type=template&id=433b74f4&scoped=true"
import script from "./ConfigureDeal.vue?vue&type=script&lang=js"
export * from "./ConfigureDeal.vue?vue&type=script&lang=js"

import "./ConfigureDeal.vue?vue&type=style&index=0&id=433b74f4&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-433b74f4"]])

export default __exports__